class CartCrossSell {
  constructor() {
    this.handleClick = this.handleClick.bind(this);

    document.addEventListener('click', this.handleClick);
  }

  async handleClick(event) {
    const button = event.target.closest('[data-cross-sell-add]');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.disabled) {
      return;
    }

    const variantId = button.dataset.variantId;

    if (!variantId) {
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    try {
      const cartDrawer = document.querySelector('cart-drawer');

      const sections = [];

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        cartDrawer.getSectionsToRender().forEach((section) => {
          if (section.section) {
            sections.push(section.section);
          } else if (section.id) {
            sections.push(section.id);
          }
        });
      }

      const body = {
        items: [
          {
            id: Number(variantId),
            quantity: 1,
          },
        ],
      };

      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
          responseData.message ||
          'Produkt konnte nicht hinzugefügt werden.'
        );
      }

      if (
        cartDrawer &&
        responseData.sections &&
        typeof cartDrawer.renderContents === 'function'
      ) {
        cartDrawer.renderContents(responseData);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Cart Cross Sell:', error);

      button.disabled = false;
      button.classList.remove('is-loading');

      alert(
        error.message ||
        'Das Produkt konnte leider nicht zum Warenkorb hinzugefügt werden.'
      );
    }
  }
}

if (!window.cartCrossSellInitialized) {
  window.cartCrossSellInitialized = true;
  new CartCrossSell();
}